import { Box } from '@primer/react';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import InfoTooltipWithIcon from '@upright/ui/common/generic/components/tooltips/info-tooltip-with-icon';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import OriginIcon from '@upright/ui/icons/img/streamline-light/logos/video-games/origin.svg';
import LensIcon from '@upright/ui/icons/img/streamline-mini-line/images-photography/lenses/image-lens.svg';
import styled from 'styled-components';
import { NetImpactLensTipPopover } from '../../../impact-lenses/net-impact/lens-tip-popover';
import { useCarouselContext } from '../../context';
import { SingleEntityLensData } from '../../types';

export function LensDescription() {
  const context = useCarouselContext();
  const lens = context.lens;
  const data = context.data;
  const showTooltip = !context.options.hideTooltips;
  return (
    <>
      <LensIcon style={{ height: '1.0em', width: '1.0em' }} />
      <Box position="relative">
        <Title>Lens</Title>
        <NetImpactLensTipPopover data={data as SingleEntityLensData<ImpactLensType>} />
      </Box>
      <Description data-testid={E2eTestElementId.LENS_DESCRIPTION}>
        <lens.LensDescription />
      </Description>
      {showTooltip && (
        <InfoTooltipWithIcon
          content={<lens.LensTooltipContent data={data} />}
          style={{ marginLeft: '0.4em' }}
          maxWidth={'350px'}
        />
      )}
    </>
  );
}

export function LensSource() {
  const context = useCarouselContext();
  const lens = context.lens;
  const showTooltip = !context.options.hideTooltips;
  return (
    <>
      <OriginIcon stroke="currentColor" style={{ height: '1.0em', width: '1.0em' }} />
      <Title>Source</Title>
      <Description>
        <lens.SourceDescription />
      </Description>
      {showTooltip && (
        <InfoTooltipWithIcon
          content={<lens.SourceTooltipContent />}
          style={{ marginLeft: '0.4em' }}
          maxWidth={'350px'}
        />
      )}
    </>
  );
}

// export function LensSourceAndDescription() {
//   const context = useCarouselContext();
//   const lens = context.lens;
//   const layout = useCarouselLayout();
//   const area = layout.topDescriptionsArea();
//   const center = area.x1 + area.width / 2;
//   const margin = 10;
//   const height = area.height;
//
//
//   function getStyles() {
//     if (area.narrowMode) {
//       console.log('in narrowMode');
//       const leftStyle: React.CSSProperties = {
//         top: area.y1,
//         left: area.x1,
//         width: area.width,
//         height: height / 2,
//         justifyContent: 'center',
//       };
//       const rightStyle: React.CSSProperties = {
//         ...leftStyle,
//         top: area.y1 + height / 2,
//       };
//       return { leftStyle, rightStyle };
//     } else {
//       const leftStyle: React.CSSProperties = {
//         right: center + margin,
//         top: area.y1,
//         left: area.x1,
//         height,
//         justifyContent: 'flex-end',
//       };
//       const rightStyle: React.CSSProperties = {
//         left: center + margin,
//         top: area.y1,
//         right: 0,
//         height,
//         justifyContent: 'flex-start',
//       };
//       return { leftStyle, rightStyle };
//     }
//   }
//
//   const { leftStyle, rightStyle } = getStyles();
//
//   return (
//     <Root>
//       <Left style={leftStyle}>
//         <LensIcon style={{ height: '1.0em', width: '1.0em' }} />
//         <Title>Lens</Title>
//         <lens.LensDescription />
//         <InfoTooltipWithIcon content={<lens.LensTooltipContent />} style={{ marginLeft: '0.4em' }} />
//       </Left>
//       <Right style={rightStyle}>
//         <OriginIcon stroke="currentColor" style={{ height: '1.0em', width: '1.0em' }} />
//         <Title>Source</Title>
//         <lens.SourceDescription />
//         <InfoTooltipWithIcon content={<lens.SourceTooltipContent />} style={{ marginLeft: '0.4em' }} />
//       </Right>
//     </Root>
//   );
// }

// const Root = styled.div``;

const Title = styled.div`
  margin-left: 0.5em;
  margin-right: 0.5em;
  font-weight: 500;
  text-transform: uppercase;
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
`;

const Description = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// const Left = styled.div`
//   position: absolute;
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
// `;
//
// const Right = styled.div`
//   position: absolute;
//   display: flex;
//   justify-content: flex-start;
//   align-items: center;
// `;
